import BaseAPI from '@/services/api/internal/tools/baseAPI';
import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';
import Client from '../tools/client';

const SetupParamsApi = new BaseAPI({
  url: `heating_ignition/api/v1/setup-params`,
});

// const SetupParamsApi = new BaseAPI({
//   url: `http://localhost:3000/setup-params`,
// });

SetupParamsApi.patchItem = function patchItem(item, id) {
  return Client.put(`${this.url}/${id}`, item).catch(errorHandler);
};

SetupParamsApi.deleteItem = function deleteItem(id) {
  return Client.delete(`${this.url}/${id}`).catch(errorHandler);
};

export default SetupParamsApi;
